import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxCheckedIcon from '@material-ui/icons/CheckBox';
import CheckBoxIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckedIcon from '@material-ui/icons/IndeterminateCheckBox';

const Checkbox = ({ id, name, onChange, checked, checkedAll, label, error, disabled, small, className }) => {
  let cssClass = 'checkbox'

  if(small) {
    cssClass += ' checkbox--small'
  }
  if(disabled) {
    cssClass += ' checkbox--disabled'
  }
  if(className) {
    cssClass += ` ${className}`
  }

  return(
    <div className={cssClass}>
      <label htmlFor={id}>
        <input type="checkbox" name={name} id={id} onChange={onChange} checked={checked} disabled={disabled} />
        <div className={checked ? "checkbox__btn checked" : "checkbox__btn unchecked"}>
          {checked ? checkedAll ? <IndeterminateCheckedIcon /> : <CheckBoxCheckedIcon /> : <CheckBoxIcon />}
        </div>
        {label && <div className="checkbox__label">{label}</div>}
      </label>
      {error && <div className="checkbox__error">{error}</div>}
    </div>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  checkedAll: PropTypes.bool,
}

export default Checkbox;